import { Schema } from 'rsuite'

const { StringType, ArrayType, NumberType } = Schema.Types

export const productAttributeFormValidationModel = Schema.Model({
  name: StringType().isRequired('Заполните название'),
  value_type: StringType().isRequired('Заполните тип'),
  slug: StringType().isRequired('Заполните слаг')
})
